import React from 'react';
import { QuestionStatusesTypeForModerating } from 'views/Questions/Question.types';
import styles from './Status.module.css';

const Status = ({ type }: QuestionStatusesTypeForModerating) => {
  const moderating = type && type === 'moderating';

  return (
    <div
      className={`${styles.wrapper} ${
        moderating ? styles.wrapper__moderating : styles.wrapper__declined
      }`}
    >
      <div
        className={`${styles.icon} ${
          moderating ? styles.icon__moderating : styles.icon__declined
        }`}
      />
      <span className={styles.text} data-qa-marker="qstn_status">
        {moderating ? 'Вопрос ещё не проверен' : 'Вопрос отклонён'}
      </span>
    </div>
  );
};

export default Status;
